import React from 'react';
import Header from './Header';
import HeroSectionSandbox from './HeroSectionSandbox';
import ProblemStatement from './ProblemStatement';
import ProductIntroSection from './ProductIntroSection';
import HowItWorksSection from './HowItWorksSection';
import CostImpactSection from './CostImpactSection';
import NurseTestimonialsSection from './NurseTestimonialsSection';
import RegulatoryComplianceSection from './RegulatoryComplianceSection';
import SolutionOverview from './SolutionOverview';
import EarlyMobilitySection from './EarlyMobilitySection';
import VideoSection from './VideoSection';

import FeedbackGallerySection from './FeedbackGallerySection';
import FAQSection from './FAQSection';
import Footer from './Footer';
import FloatingActionWidget from './FloatingActionWidget';
import InstitutionsBanner from './InstitutionsBanner';
import HowItWorksImageSection from './HowItWorksImageSection';
// import SurveyInsightsSection from './SurveyInsightsSection'; // Dark version - hidden for now
import SurveyInsightsLight from './SurveyInsightsLight';

const LandingPageSandbox = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Sandbox Hero Section with Background Image */}
        <HeroSectionSandbox />

        {/* Existing Problem Stats Bar */}
        <ProblemStatement />

        {/* NEW: Product Introduction - What is Cordflex? */}
        <ProductIntroSection />

        {/* Institutions Banner - Social Proof */}
        <InstitutionsBanner />

        {/* NEW: How It Works - Step by Step Guide 
        <HowItWorksSection />*/}

        {/* How It Works - Image Version (testing) */}
        <HowItWorksImageSection />

        {/* Existing Video Section - Moved here after product intro */}
        <VideoSection />

        {/* Survey Insights - Light Theme Version */}
        <SurveyInsightsLight />

        {/* NEW: Cost Impact - For Decision Makers */}
        <CostImpactSection />

        {/* Feedback Gallery - Trusted by Healthcare Professionals */}
        <FeedbackGallerySection />

        {/* Survey Insights - Dark Version - HIDDEN FOR COMPARISON, keeping light version above */}
        {/* <SurveyInsightsSection /> */}

        {/* NEW: Regulatory Compliance - For Compliance Officers */}
        <RegulatoryComplianceSection />

        {/* Existing Solution Overview */}
        <SolutionOverview />

        {/* NEW: Early Mobility & Patient Outcomes */}
        <EarlyMobilitySection />

        {/* NEW: Nurse Testimonials - Nurses Say It Best */}
        <NurseTestimonialsSection />

        {/* Existing FAQ Section */}
        <FAQSection />
      </main>
      <Footer />
      <FloatingActionWidget />
    </div>
  );
};

export default LandingPageSandbox;
